import React from 'react';

import {COLUMN_WIDTHS, SCOPE_KEY} from 'src/modules/profile/user/tabs/content/layouts/util';
import {UserLayoutRequestSortBy} from 'src/openapi/admin/models/UserLayoutRequest';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';
import {Cell} from '@pb/kit-component-table';

import {uiToApiSort} from '../../utils/util';
import {useLayoutCriteria} from '../hooks/useLayoutCriteria';

export const LayoutNameHeader = () => {
    const {criteria, setSort} = useLayoutCriteria(SCOPE_KEY);

    return (
        <Cell width={COLUMN_WIDTHS.NAME} className="nowrap">
            <SortHeaderWithDataTable
                caption="Layout Name"
                defaultDirection="ASC"
                direction={criteria?.sortBy === UserLayoutRequestSortBy.NAME
                    ? criteria.sortDirection
                    : undefined}
                onSort={dir => setSort(UserLayoutRequestSortBy.NAME, uiToApiSort(dir))}
            />
        </Cell>
    );
};
